export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Pesquisar',
  catalogHeaderTitle: 'Detalhes',
  catalogDetailsCurtainCopyOptionTitle: 'Copiar link',
  catalogDetailsLinkCopiedAlertText: 'Link copiado!',
  catalogDetailsCurtainFlagOptionTitle: 'Denunciar conteúdo',
  catalogDetailsFlagCurtainTitle: 'Denunciar',
  catalogReportedCurtainContent: 'Conteúdo denunciado',
  catalogWantBuy: 'Quer comprar {item} de {app}',
  catalogInterestedIn: '{link}'
}
